import { PRIVATE_USER } from "Shared/Routing/Application/Constants/PathsConstant";

export const PRIVATE_USER_LIST_UNION_DELEGATION_SERVICE = PRIVATE_USER + '/list-union-service-delegation';
export const PRIVATE_USER_FORM_UNION_DELEGATION_SERVICE = PRIVATE_USER + '/form-union-service-delegation';

export const PRIVATE_USER_LIST_CONTRACT_DELEGATION_SERVICE = PRIVATE_USER + '/list-contract-delegation-service';
export const PRIVATE_USER_FORM_CONTRACT_DELEGATION_SERVICE = PRIVATE_USER + '/form-contract-delegation-service';

export const PRIVATE_USER_LIST_CONTACT_DELEGATION_SERVICE = PRIVATE_USER + '/list-contact-delegation-service';
export const PRIVATE_USER_FORM_CONTACT_DELEGATION_SERVICE = PRIVATE_USER + '/form-contact-delegation-service';

export const PRIVATE_USER_LIST_DELEGATION_SERVICE = PRIVATE_USER + '/delegation-service';
export const PRIVATE_USER_FORM_DELEGATION_SERVICE = PRIVATE_USER + '/delegation-service';

export const PRIVATE_USER_LIST_SERVICE_COMPANY = PRIVATE_USER + '/list-service-company';
export const PRIVATE_USER_FORM_SERVICE_COMPANY = PRIVATE_USER + '/form-service-company';

export const PRIVATE_USER_GESTION_DE_SERVICIOS = PRIVATE_USER + '/gestion-de-servicios';
export const PRIVATE_USER_DELEGATION = PRIVATE_USER + '/delegation';
export const PRIVATE_USER_SERVICIOS_CONTRATADOS = PRIVATE_USER + '/servicios_contratados';